module.exports = __webpack_public_path__ + "static/media/facebook-circular-logo.2208671f.png";